import {
  createResourceReducer,
  updateResourceState,
  defaultResourceState,
  RESOURCE
} from 'react-structure-admin';

import {
  EVENT,
  EVENT_CHANGE_STATUS,
  EVENT_CHANGE_STATUS_FINISHED,
  EVENT_DELETE,
  EVENT_DELETE_FINISHED,
  EVENT_FETCH_APPOINTMENT_TODAY,
  EVENT_FETCH_APPOINTMENT_TODAY_FINISHED,
  EVENT_FETCH_FAST_SEARCH,
  EVENT_FETCH_FAST_SEARCH_FINISHED,
  EVENT_GET_VIEW,
  EVENT_GET_VIEW_CLOSE,
  EVENT_GET_VIEW_FINISHED,
  EVENT_REFRESH,
  EVENT_SCHEDULES,
  EVENT_SCHEDULES_FINISHED,
  EVENT_SCHEDULES_UNLOAD
} from './eventActions';

const eventReducer = createResourceReducer(
  EVENT,
  [],
  {
    [EVENT_FETCH_FAST_SEARCH](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        queryParams: action.payload
      }));
    },

    [EVENT_FETCH_FAST_SEARCH_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        items: action.payload.data.result,
        loaded: true
      }));
    },

    [EVENT_REFRESH](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loaded: false
      }));
    },

    [EVENT_FETCH_APPOINTMENT_TODAY](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loading: true
      }));
    },

    [EVENT_FETCH_APPOINTMENT_TODAY_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        appointmentTodayItems: action.payload.data.result.items,
        loading: false
      }));
    },

    [EVENT_GET_VIEW](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loading: true
      }));
    },

    [EVENT_CHANGE_STATUS](state, action) {
      return updateResourceState(
        state,
        action,
        RESOURCE,
        ({ view, items = [] }) => ({
          updatingStatus: true,
          items: items.map((c) => {
            if (c.id === view.id) {
              return { ...c, status: action.payload };
            }

            return c;
          })
        })
      );
    },

    [EVENT_CHANGE_STATUS_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        view: {
          ...action.payload.data.result
        },
        updatingStatus: false
      }));
    },

    [EVENT_DELETE](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        deletingId: action.payload
      }));
    },

    [EVENT_DELETE_FINISHED](state, action) {
      return updateResourceState(
        state,
        action,
        RESOURCE,
        ({ items = [], deletingId }) => ({
          deletingId: null,
          items: items.filter((c) => c.id !== deletingId),
          view: null
        })
      );
    },

    [EVENT_GET_VIEW_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => {
        return {
          view: action.payload.data.result,
          loading: false
        };
      });
    },

    [EVENT_GET_VIEW_CLOSE](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        view: null
      }));
    },

    [EVENT_SCHEDULES](state, action) {
      return updateResourceState(state, action, RESOURCE, (resource) => ({
        schedules: {
          ...(resource?.schedules ?? defaultResourceState),
          loading: true
        }
      }));
    },

    [EVENT_SCHEDULES_FINISHED](state, action) {
      return updateResourceState(
        state,
        action,
        RESOURCE,
        ({ schedules = {} }) => ({
          schedules: {
            ...schedules,
            pagination: {
              ...schedules?.pagination,
              total: action.payload.data.result.totalCount,
              current: Number(action.payload.config.params?.page) || 1
            },
            ...action.payload.data.result,
            queryParams: action.payload.config.params,
            loaded: true,
            saving: false,
            loading: false
          }
        })
      );
    },

    [EVENT_SCHEDULES_UNLOAD](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        schedules: {}
      }));
    }
  },
  (state, action) => {
    return updateResourceState(state, action, RESOURCE, () => {
      return {
        loading: false,
        deletingId: null,
        updatingStatus: false
      };
    });
  }
);

export default eventReducer;
